import { FC, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ExoSkeletonApi: FC = () => {
  const navigate = useNavigate();
  const handleNavigateRequest = useCallback(
    ({ detail }: { detail: string }) => {
      if (typeof detail === 'string') {
        navigate(detail);
      }
    },
    [navigate]
  );

  useEffect(() => {
    window.addEventListener('exo-skeleton:navigate', handleNavigateRequest);
    return () => {
      window.removeEventListener(
        'exo-skeleton:navigate',
        handleNavigateRequest
      );
    };
  }, [handleNavigateRequest]);

  return null;
};

export default ExoSkeletonApi;
